/**
 * Tiny inline SVG icon per domain. Uses `currentColor` so the
 * containing element's text color drives the fill — callers pair it
 * with `text-domain-<name>` utilities for a color match.
 */

import type { NormalizedDomain } from '@/api/types';

export function DomainIcon({
  domain,
  className,
}: {
  domain: NormalizedDomain;
  className?: string;
}) {
  const props = {
    viewBox: '0 0 24 24',
    fill: 'none',
    stroke: 'currentColor',
    strokeWidth: 1.8,
    strokeLinecap: 'round' as const,
    strokeLinejoin: 'round' as const,
    className,
    'aria-hidden': true,
  };

  switch (domain) {
    case 'audio':
      return (
        <svg {...props}>
          <path d="M4 12h2m3 0h2m3 0h2m3 0h2" />
          <path d="M7 8v8M11 5v14M15 7v10M19 10v4" />
        </svg>
      );
    case 'process':
      return (
        <svg {...props}>
          <rect x="3" y="4" width="7" height="5" rx="1" />
          <rect x="14" y="4" width="7" height="5" rx="1" />
          <rect x="8.5" y="15" width="7" height="5" rx="1" />
          <path d="M6.5 9v3h11v-3M12 12v3" />
        </svg>
      );
    case 'medical':
      return (
        <svg {...props}>
          <path d="M12 3v18M3 12h18" />
          <circle cx="12" cy="12" r="9" />
        </svg>
      );
    case 'financial':
      return (
        <svg {...props}>
          <circle cx="12" cy="8" r="4" />
          <path d="M4 20c0-3 3.5-5 8-5s8 2 8 5" />
        </svg>
      );
    case 'defense':
      return (
        <svg {...props}>
          <path d="M12 3l8 3v6c0 5-4 8-8 9-4-1-8-4-8-9V6l8-3z" />
        </svg>
      );
    case 'government':
      return (
        <svg {...props}>
          <path d="M3 10h18M4 10l8-5 8 5" />
          <path d="M6 10v8M10 10v8M14 10v8M18 10v8" />
          <path d="M3 20h18" />
        </svg>
      );
    case 'conductor':
      return (
        <svg {...props}>
          <circle cx="6" cy="7" r="2" />
          <circle cx="18" cy="7" r="2" />
          <circle cx="12" cy="17" r="2" />
          <path d="M7.6 8.6L10.6 15.6M16.4 8.6L13.4 15.6" />
        </svg>
      );
    case 'generic':
    default:
      return (
        <svg {...props}>
          <rect x="4" y="4" width="16" height="16" rx="2" />
          <path d="M8 12h8" />
        </svg>
      );
  }
}
